import React from 'react';
import Layout from '../../components/Layout';
import Banner from '../../components/Banner';

const Home = () => {
  return (
    <Layout title="Home">
      <Banner/>
    </Layout>
  );
}

export default Home;